import _ from 'lodash';
import React from 'react';
import PropTypes from 'prop-types';
import { commitMutation, graphql } from 'react-relay';
import LibraryDesktop from './LibraryDesktop';
import LibraryMobile from './LibraryMobile';
import globalStyles from '../../../globals.scss';
import { Button, Divider } from 'semantic-ui-react';
import ReactCSSTransitionGroup from 'react-addons-css-transition-group';
import '../../../../lib/stylesheets/SlideTransition.scss';
import LibraryItemEditMobile from './LibraryItemEditMobile';
import { Analytics, GlobalNotifications, Intent } from '../../../Modules';
import nullifyEmptyStrings from '../../../../lib/utils/nullifyEmptyStrings';

export default class ServiceLibrary extends React.Component {
  static propTypes = {
    initiallyExpanded: PropTypes.bool,
    newLibraryLineItem: PropTypes.object.isRequired,
    createLineItem: PropTypes.func.isRequired,
    copyLibraryLineItemsToDocument: PropTypes.func.isRequired,
    readOnly: PropTypes.bool,
    viewer: PropTypes.object.isRequired,
    relay: PropTypes.object.isRequired,
    newLibraryLineItemChangeHandler: PropTypes.func.isRequired,
    resetNewLibraryLineItem: PropTypes.func.isRequired
  };

  constructor(props) {
    super(props);
    this.serviceSelectHandler = this.serviceSelectHandler.bind(this);
    this.toggleServiceSelect = this.toggleServiceSelect.bind(this);
    this.selectAll = this.selectAll.bind(this);
    this.selectNone = this.selectNone.bind(this);
    this.addSelected = this.addSelected.bind(this);
    this.getTotalSelected = this.getTotalSelected.bind(this);
    this.toggleMobileLibrary = this.toggleMobileLibrary.bind(this);
    this.toggleMobileAdd = this.toggleMobileAdd.bind(this);
    this.getFilteredLibrary = this.getFilteredLibrary.bind(this);
    this.updateSearchQuery = this.updateSearchQuery.bind(this);
    this.lineItemChangeHandler = this.lineItemChangeHandler.bind(this);
    this.lineItemCheckedHandler = this.lineItemCheckedHandler.bind(this);
    this.updateLibraryLineItem = this.updateLibraryLineItem.bind(this);
    this.deleteLibraryLineItem = this.deleteLibraryLineItem.bind(this);
    this.resetEditLibraryLineItem = this.resetEditLibraryLineItem.bind(this);
    this.getLocalLineItems = this.getLocalLineItems.bind(this);
    this.state = {
      searchQuery: '',
      showMobileAdd: false,
      showMobileLibrary: false,
      localLibraryLineItems: this.props.viewer
        ? _.cloneDeep(this.props.viewer.user_line_items.edges)
        : []
    };
  }

  componentWillReceiveProps(nextProps) {
    // Update localLibraryLineItems if any edges are added/deleted
    if (
      this.state.localLibraryLineItems.length !==
      nextProps.viewer.user_line_items.edges.length
    ) {
      const obj = _.cloneDeep(this.state);
      obj.localLibraryLineItems = _.cloneDeep(
        nextProps.viewer.user_line_items.edges
      );
      this.setState({ ...obj });
    }
  }

  getLocalLineItems() {
    return this.getFilteredLibrary(
      this.state.localLibraryLineItems,
      this.state.searchQuery
    );
  }

  getFilteredLibrary(library, query) {
    return library.filter(
      item => item.node.title.toLowerCase().indexOf(query.toLowerCase()) !== -1
    );
  }

  getTotalSelected() {
    const libraryLineItems = _.cloneDeep(this.state.localLibraryLineItems);
    let selected = 0;
    libraryLineItems.map(lineItem => {
      if (lineItem.checked) selected += 1;
      return lineItem;
    });
    return selected;
  }

  // Handler for Semantic UI checkbox element
  serviceSelectHandler(idx, e, data) {
    const localLibraryItem = _.cloneDeep(this.getLocalLineItems()[idx]);
    localLibraryItem.checked = data.checked;
    this.lineItemCheckedHandler(localLibraryItem, idx);
  }

  // Handler for selectable div touch target
  toggleServiceSelect(idx) {
    const localLibraryItem = _.cloneDeep(this.getLocalLineItems()[idx]);
    localLibraryItem.checked = !localLibraryItem.checked;
    this.lineItemCheckedHandler(localLibraryItem, idx);
  }

  selectAll() {
    this.getLocalLineItems().map((lineItem, idx) => {
      this.lineItemCheckedHandler(
        Object.assign({}, lineItem, { checked: true }),
        idx
      );
      return lineItem;
    });
  }

  selectNone() {
    const localLibraryLineItems = _.cloneDeep(this.state.localLibraryLineItems);
    localLibraryLineItems.map((lineItem, idx) => {
      localLibraryLineItems[idx].checked = false;
      return lineItem;
    });
    this.setState({ localLibraryLineItems });
  }

  addSelected() {
    const itemsToCopy = this.state.localLibraryLineItems
      .filter(lineItem => lineItem.checked)
      .map(lineItem => lineItem.node.id);
    this.props.copyLibraryLineItemsToDocument(itemsToCopy);
    this.selectNone();
  }

  toggleMobileLibrary(showMobileLibrary) {
    if (typeof showMobileLibrary === 'boolean') {
      this.setState({ showMobileLibrary });
    } else {
      this.setState({ showMobileLibrary: !this.state.showMobileLibrary });
    }
  }

  toggleMobileAdd(showMobileAdd, addToLibrary = false) {
    if (typeof showMobileAdd === 'boolean') {
      this.setState({ showMobileAdd });
    } else {
      this.setState({ showMobileAdd: !this.state.showMobileAdd });
    }
    this.props.newLibraryLineItemChangeHandler(
      Object.assign({}, this.props.newLibraryLineItem, { addToLibrary })
    );
  }

  updateSearchQuery(e) {
    this.setState({ searchQuery: e.target.value });
  }

  // Handles changes to a library line item node
  lineItemChangeHandler(lineItem, idx) {
    const id = this.getLocalLineItems()[idx].node.id;
    const localLibraryLineItems = _.cloneDeep(this.state.localLibraryLineItems);
    localLibraryLineItems.map((localLineItem, index) => {
      if (localLineItem.node.id === id) {
        localLibraryLineItems[index].node = lineItem;
      }
      return localLineItem;
    });
    this.setState({ localLibraryLineItems });
  }

  // Handles whether a library line item is checked or not
  lineItemCheckedHandler(lineItem, idx) {
    const id = this.getLocalLineItems()[idx].node.id;
    this.setState(prevState => {
      const obj = _.cloneDeep(prevState);
      obj.localLibraryLineItems.map((localLineItem, index) => {
        if (localLineItem.node.id === id) {
          obj.localLibraryLineItems[index] = lineItem;
        }
        return localLineItem;
      });
      return obj;
    });
  }

  updateLibraryLineItem(idx, successCb, failureCb) {
    const onError = () => {
      if (failureCb) failureCb();
      GlobalNotifications.show({
        message: 'Unable to update line item',
        intent: Intent.DANGER
      });
    };
    const onCompleted = () => {
      if (successCb) successCb();
      GlobalNotifications.show({
        message: 'Successfully updated line item',
        intent: Intent.SUCCESS
      });
      Analytics.trackEvent('updated-library-line-item');
    };
    const lineItem = _.pick(
      nullifyEmptyStrings(this.getLocalLineItems()[idx].node),
      [
        'id',
        'description',
        'position',
        'price_cents',
        'price_currency',
        'quantity',
        'title'
      ]
    );

    lineItem.quantity = parseInt(lineItem.quantity, 10);

    const mutation = graphql`
      mutation Library_updateUserLineItemMutation(
        $input: UpdateUserLineItemInput!
      ) {
        updateUserLineItem(input: $input) {
          user_line_item {
            id
            description
            price_cents
            price_currency
            quantity
            title
          }
        }
      }
    `;

    const optimisticResponse = {
      updateUserLineItem: { user_line_item: _.cloneDeep(lineItem) }
    };
    const environment = this.props.relay.environment;

    commitMutation(environment, {
      mutation,
      variables: {
        input: {
          ...lineItem
        }
      },
      optimisticResponse,
      onCompleted,
      onError
    });
  }

  deleteLibraryLineItem(idx, successCb, failureCb) {
    /* eslint-disable no-unused-vars */
    const onError = () => {
      if (failureCb) failureCb();
      GlobalNotifications.show({
        message: 'Unable to delete line item',
        intent: Intent.DANGER
      });
    };

    const onCompleted = () => {
      if (successCb) successCb();
      GlobalNotifications.show({
        message: 'Successfully deleted line item',
        intent: Intent.SUCCESS
      });
      Analytics.trackEvent('deleted-library-line-item');
    };

    const mutation = graphql`
      mutation Library_deleteUserLineItemMutation(
        $input: DeleteUserLineItemInput!
      ) {
        deleteUserLineItem(input: $input) {
          deletedUserLineItemId
        }
      }
    `;

    const environment = this.props.relay.environment;
    const parentID = this.props.viewer.id;

    const configs = [
      {
        type: 'RANGE_DELETE',
        parentID,
        pathToConnection: ['viewer', 'user_line_items'],
        deletedIDFieldName: 'deletedUserLineItemId',
        connectionKeys: [
          {
            key: 'LibraryContainer_user_line_items',
            rangeBehavior: 'append'
          }
        ]
      }
    ];

    commitMutation(environment, {
      mutation,
      variables: {
        input: {
          id: this.getLocalLineItems()[idx].node.id
        }
      },
      configs,
      onCompleted,
      onError
    });
  }

  resetEditLibraryLineItem(idx) {
    const id = this.getLocalLineItems()[idx].node.id;
    const localLibraryLineItems = _.cloneDeep(this.state.localLibraryLineItems);
    localLibraryLineItems.map((localLineItem, index) => {
      if (localLineItem.node.id === id) {
        localLibraryLineItems[index].node = _.cloneDeep(
          this.props.viewer.user_line_items.edges[idx].node
        );
      }
      return localLineItem;
    });
    this.setState({ localLibraryLineItems });
  }

  render() {
    const userLineItems = this.props.viewer.user_line_items.edges;
    return (
      <div>
        <div className={globalStyles.desktop}>
          <LibraryDesktop
            serviceChangeHandler={this.lineItemChangeHandler}
            updateService={this.updateLibraryLineItem}
            resetEditService={this.resetEditLibraryLineItem}
            deleteService={this.deleteLibraryLineItem}
            newLibraryLineItemChangeHandler={
              this.props.newLibraryLineItemChangeHandler
            }
            createService={this.props.createLineItem}
            resetAddService={this.props.resetNewLibraryLineItem}
            library={this.getFilteredLibrary(
              userLineItems,
              this.state.searchQuery
            )}
            searchQuery={this.state.searchQuery}
            updateSearchQuery={this.updateSearchQuery}
            localLibrary={this.getFilteredLibrary(
              this.state.localLibraryLineItems,
              this.state.searchQuery
            )}
            serviceSelectHandler={this.serviceSelectHandler}
            toggleServiceSelect={this.toggleServiceSelect}
            selectAll={this.selectAll}
            selectNone={this.selectNone}
            addSelected={this.addSelected}
            getTotalSelected={this.getTotalSelected}
            initiallyExpanded={this.props.initiallyExpanded}
            newService={this.props.newLibraryLineItem}
            readOnly={this.props.readOnly}
          />
        </div>
        <div className={globalStyles.mobile} style={{ textAlign: 'center' }}>
          <Button
            onClick={this.toggleMobileLibrary.bind(null, true)}
            positive
            content='Add from Library'
            fluid
          />
          <Divider horizontal>Or</Divider>
          <Button
            onClick={this.toggleMobileAdd.bind(null, true, false)}
            content='Add New Item'
            fluid
          />
          <ReactCSSTransitionGroup
            transitionName='slide'
            transitionEnterTimeout={300}
            transitionLeaveTimeout={300}
          >
            {this.state.showMobileLibrary &&
              <LibraryMobile
                serviceChangeHandler={this.lineItemChangeHandler}
                updateService={this.updateLibraryLineItem}
                resetEditService={this.resetEditLibraryLineItem}
                deleteService={this.deleteLibraryLineItem}
                library={this.getFilteredLibrary(
                  userLineItems,
                  this.state.searchQuery
                )}
                searchQuery={this.state.searchQuery}
                updateSearchQuery={this.updateSearchQuery}
                localLibrary={this.getFilteredLibrary(
                  this.state.localLibraryLineItems,
                  this.state.searchQuery
                )}
                serviceSelectHandler={this.serviceSelectHandler}
                toggleServiceSelect={this.toggleServiceSelect}
                selectAll={this.selectAll}
                selectNone={this.selectNone}
                addSelected={this.addSelected}
                getTotalSelected={this.getTotalSelected}
                open={this.state.showMobileLibrary}
                toggleMobileLibrary={this.toggleMobileLibrary}
                toggleMobileAdd={this.toggleMobileAdd}
                readOnly={this.props.readOnly}
              />}
          </ReactCSSTransitionGroup>
          <ReactCSSTransitionGroup
            transitionName='slide'
            transitionEnterTimeout={300}
            transitionLeaveTimeout={300}
          >
            {!this.props.readOnly &&
              this.state.showMobileAdd &&
              <LibraryItemEditMobile
                localService={this.props.newLibraryLineItem}
                commitUpdate={this.props.createLineItem}
                reset={this.props.resetNewLibraryLineItem}
                onChange={this.props.newLibraryLineItemChangeHandler}
                closeHandler={this.toggleMobileAdd.bind(null, false, false)}
                isNew
                open={this.state.showMobileAdd}
              />}
          </ReactCSSTransitionGroup>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./webpack/components/Document/Sections/Library/Library.js